import {Component, Input, OnInit} from '@angular/core';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import _ from 'lodash';

@Component({
  selector: 'manipulation-grid',
  templateUrl: './manipulation-grid.component.html',
  styleUrls: ['./manipulation-grid.component.scss']
})
export class ManipulationGridComponent implements OnInit {

  keyMap = {};

  @Input() gridId: string;

  displayedColumns: Array<DisplayedColumnInf>;

  manipulationData: [];

  @Input() public set data(man){

    for (const [key, value] of Object.entries(man[0])) {
      this.keyMap[key] = key + this.gridId;
    }

    const dataWithUpdatedKeys = man.map(obj => _.mapKeys(obj, (value, key) => this.keyMap[key]));
    this.manipulationData = dataWithUpdatedKeys;
  }

  constructor() {

  }

  ngOnInit(): void {

    this.displayedColumns = [
      {name: 'usedInRouting' + this.gridId, display: 'Used in routing', selected: true, width: 80},
      {name: 'originalValue' + this.gridId, display: 'Original', selected: true, width: 200},
      {name: 'manipulatedValue' + this.gridId, display: 'New', selected: true, width: 200},
      {name: 'manipulatedEntity' + this.gridId, display: 'Entity', selected: true, width: 200},
      {name: 'manipulatingEntity' + this.gridId, display: 'Changed by', selected: true, width: 200},
      {name: 'usingManipulatingEntity' + this.gridId, display: 'Normalization', selected: true, width: 200},
      {name: 'unselectedRuleDescription' + this.gridId, display: 'Description', selected: true, width: 200},
    ];
  }

}
